import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import "./DisactivateDoctor.css";
import "react-toastify/dist/ReactToastify.css";
import { putDeactivateDoctorRequest } from "../../../../../service-layer/MedicalStaffService";
import LogoutModal from "../../../../components/logout-moal/LogoutModal";
import { useTranslation } from "react-i18next";
import {CButton} from "@coreui/react";

const DisactivateDoctor = ({ email }) => {
  const { t } = useTranslation();

  const [isDeactivated, setIsDeactivated] = useState(false);
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleConfirmDeactivate = () => {
    setIsDeactivated(true);

    //axios call
    putDeactivateDoctorRequest(email).then((r) => console.log(r));
    console.log("Deactivating doctor with email:", email);
    handleClose();
  };

  return (
    <div className="disactivate-doctor-button-container">
      {!isDeactivated ? (
        <>
          <CButton
              className="disactivate-doctor-button"
              onClick={handleOpen}
          >
            {t("remove")}
          </CButton>


          <LogoutModal
            show={open}
            handleConfirm={handleConfirmDeactivate}
            handleClose={handleClose}
            title={t("removeDoctorTitle")}
            message={t("removeDoctorMessage")}
            tag={"remove"}
          />
        </>
      ) : (
        <CButton
          variant="outlined"
          color="#204770"
          disabled
          className="disactivate-doctor-button-expanded"
        >
          {t("removed")}
        </CButton>
      )}
    </div>
  );
};

DisactivateDoctor.propTypes = {
  email: PropTypes.string.isRequired,
};

export default DisactivateDoctor;
